import React from "react";
import PaymentSuccess from "./PaymentSuccess";
import PaymentLoading from "./PaymentLoading";
import PaymentFailed from "./PaymentFailed";

export default function PaymentModal({
  type = "loading",
  handelModalType,
  isSubscription = false,
}) {
  return (
    <div className="fixed inset-0 w-full h-full bg-black/80 backdrop-blur-sm flex justify-center items-center z-50 px-4 py-3 md:px-10">
      {type === "loading" ? (
        <PaymentLoading />
      ) : type === "success" ? (
        <PaymentSuccess
          handelModalType={handelModalType}
          isSubscription={isSubscription}
        />
      ) : (
        <PaymentFailed handelModalType={handelModalType} />
      )}
    </div>
  );
}

